"use strict";var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;exports.__esModule = true;exports.styles = void 0;var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));var _Emotion = require("../../lib/theming/Emotion");var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;


var styles = exports.styles = (0, _Emotion.memoizeStyle)({
  root: function root(t) {
    return (0, _Emotion.css)(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n      background: ", ";\n      height: ", ";\n      position: absolute;\n      transition: all 0.2s ease-out;\n      border-radius: ", ";\n    "])),
    t.tabColorFocus,
    t.tabBorderWidth,


    t.tabIndicatorBorderRadius);

  },

  primary: function primary(t) {
    return (0, _Emotion.css)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteralLoose2.default)(["\n      background: ", ";\n    "])),
    t.tabColorPrimary);

  },

  success: function success(t) {
    return (0, _Emotion.css)(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteralLoose2.default)(["\n      background: ", ";\n    "])),
    t.tabColorSuccess);

  },

  warning: function warning(t) {
    return (0, _Emotion.css)(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteralLoose2.default)(["\n      background: ", ";\n    "])),
    t.tabColorWarning);

  },

  error: function error(t) {
    return (0, _Emotion.css)(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteralLoose2.default)(["\n      background: ", ";\n    "])),
    t.tabColorError);

  }
});